import URI from 'urijs';
import {ajaxAuthed, API_BASE} from "./common";

export function reportError$({ error, location, state, timestamp }) {
  const url = URI.joinPaths(API_BASE, 'errors');
  const browser = {};
  for (let property in navigator) browser[property] = navigator[property];
  console.log('reporting', { error, url: location, redux: state, datecreated: timestamp, browser });
  return ajaxAuthed({
    url: url.toString(),
    method: 'POST',
    body: { error, url: location, redux: state, datecreated: timestamp, browser },
    headers: { 'Content-Type': 'application/json' }
  });
}




// WEBPACK FOOTER //
// ./src/services/ui.js